import { min } from 'date-fns';
function getEarliestDateSafely(dates) {
  if (!dates) return null;
  const finalDates = [];
  dates.forEach(date => date instanceof Date && finalDates.push(date));
  return finalDates.length > 0 ? min(finalDates) : null;
}
export default getEarliestDateSafely;
//# sourceMappingURL=getEarliestDateSafely.js.map